import { useMutation } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";
import { useUpdateUserQueries } from "@/queries/query-users";
import { useOnError } from "@/utils/on-error";

export function useSetUserWriteAccess() {
  const updateUserQueries = useUpdateUserQueries();
  const onError = useOnError("Gebruiker schrijfrechten veranderen mislukt.");
  return useMutation({
    mutationFn: async ({
      id,
      email,
      writeAccess,
    }: {
      id: number;
      email: string;
      writeAccess: boolean;
    }) => {
      const user = await getTbiApi().UsersApi.usersUpdate({
        id: id.toString(),
        accessRule: { email, writeAccess },
      });
      updateUserQueries(user);
    },
    onError,
  });
}
